(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("ePG8R", function(module, exports) {

$parcel$export(module.exports, "use", function () { return $acc684972bd79984$export$1f96ae73734a86cc; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $hzMVT = parcelRequire("hzMVT");
function $acc684972bd79984$export$1f96ae73734a86cc(fpsOpt, leadingOpt, initialState) {
    var fps = fpsOpt !== undefined ? fpsOpt : 30;
    var leading = leadingOpt !== undefined ? leadingOpt : false;
    return $hzMVT.useThrottle(initialState, fps, leading);
}
 /* @react-hook/throttle Not a pure module */ 
});
parcelRegister("hzMVT", function(module, exports) {

$parcel$export(module.exports, "useThrottle", function () { return $ccbba99a51167ae3$export$8b7b9481d6186f21; });

var $g85JO = parcelRequire("g85JO");

var $gleUZ = parcelRequire("gleUZ");
var $ccbba99a51167ae3$var$perf = typeof performance !== "undefined" ? performance : Date;
var $ccbba99a51167ae3$var$now = function() {
    return $ccbba99a51167ae3$var$perf.now();
};
function $ccbba99a51167ae3$export$43f0d02427e1c683(callback) {
    var fps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 30, leading = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var storedCallback = (0, $gleUZ.default)(callback);
    var ms = 1000 / fps;
    var prev = $g85JO.useRef(0);
    var trailingTimeout = $g85JO.useRef();
    var clearTrailing = function() {
        return trailingTimeout.current && clearTimeout(trailingTimeout.current);
    };
    var deps = [
        fps,
        leading,
        storedCallback
    ]; // Reset any time the deps change
    function _ref() {
        prev.current = 0;
        clearTrailing();
    }
    $g85JO.useEffect(function() {
        return _ref;
    }, deps);
    return $g85JO.useCallback(function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var rightNow = $ccbba99a51167ae3$var$now();
        var call = function() {
            prev.current = rightNow;
            clearTrailing();
            storedCallback.current.apply(null, args);
        };
        var current = prev.current; // leading
        if (leading && current === 0) return call(); // body
        if (rightNow - current > ms) {
            if (current > 0) return call();
            prev.current = rightNow;
        } // trailing
        clearTrailing();
        trailingTimeout.current = setTimeout(function() {
            call();
            prev.current = 0;
        }, ms);
    }, deps);
}
function $ccbba99a51167ae3$export$8b7b9481d6186f21(initialState, fps, leading) {
    var state = $g85JO.useState(initialState);
    return [
        state[0],
        $ccbba99a51167ae3$export$43f0d02427e1c683(state[1], fps, leading)
    ];
}

});


parcelRegister("gUsPc", function(module, exports) {

$parcel$export(module.exports, "use", function () { return $c4f83c4ab738bfdf$export$1f96ae73734a86cc; });
$parcel$export(module.exports, "useContainerTop", function () { return $c4f83c4ab738bfdf$export$1ed10c548f3d9369; });
$parcel$export(module.exports, "useEffective", function () { return $c4f83c4ab738bfdf$export$e13c6a3d46905eb0; });
$parcel$export(module.exports, "useLenient", function () { return $c4f83c4ab738bfdf$export$85a6055c7d8da58f; });
$parcel$export(module.exports, "useStrict", function () { return $c4f83c4ab738bfdf$export$fccf794fa3536868; });
$parcel$export(module.exports, "useAdjustedWindowHeight", function () { return $c4f83c4ab738bfdf$export$196a7e160e85974; });
$parcel$export(module.exports, "make", function () { return $c4f83c4ab738bfdf$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $cHs0A = parcelRequire("cHs0A");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $58Tj9 = parcelRequire("58Tj9");

var $avqDR = parcelRequire("avqDR");

var $ePG8R = parcelRequire("ePG8R");

var $7GW0c = parcelRequire("7GW0c");

var $5bEXW = parcelRequire("5bEXW");

var $cTjaa = parcelRequire("cTjaa");

var $hBcYV = parcelRequire("hBcYV");

var $lx43R = parcelRequire("lx43R");

var $aSJcu = parcelRequire("aSJcu");

var $78zWm = parcelRequire("78zWm");

var $9pMGg = parcelRequire("9pMGg");

var $hv3Nv = parcelRequire("hv3Nv");

var $iJp5F = parcelRequire("iJp5F");

var $8E2YL = parcelRequire("8E2YL");
var $c4f83c4ab738bfdf$var$empty_containerRef = /*#__PURE__*/ $g85JO.createRef();
var $c4f83c4ab738bfdf$export$6e22c362a0406a2c = {
    value: 0,
    containerTop: 0,
    containerSize: undefined,
    containerRef: $c4f83c4ab738bfdf$var$empty_containerRef,
    isEffective: false,
    forceEffectiveness: false
};
var $c4f83c4ab738bfdf$export$a078c61943f9dbbe = /*#__PURE__*/ $g85JO.createContext($c4f83c4ab738bfdf$export$6e22c362a0406a2c);
var $c4f83c4ab738bfdf$export$ca328f169d304df4 = $c4f83c4ab738bfdf$export$a078c61943f9dbbe.Provider;
function $c4f83c4ab738bfdf$var$useStickySiteHeader(ref) {
    var getStickyAncestor = function getStickyAncestor(_el) {
        while(true){
            var el = _el;
            var position = window.getComputedStyle(el).position;
            if (position === "sticky" || position === "fixed") return $loT9g.some(el);
            var el$1 = el.parentElement;
            if (el$1 == null) return;
            _el = el$1;
            continue;
        }
    };
    var getStickyElement = function getStickyElement(param) {
        var el = ref.current;
        if (el == null) return null;
        var el$1 = getStickyAncestor(el);
        if (el$1 !== undefined) return $loT9g.valFromOption(el$1);
        else return null;
    };
    var match = $g85JO.useState(function() {
        return getStickyElement(undefined);
    });
    var setStickyElement = match[1];
    var stickyElement = match[0];
    var stickyElementRef = $g85JO.useMemo(function() {
        return {
            current: stickyElement
        };
    }, [
        stickyElement
    ]);
    var updateStickyElement = function updateStickyElement(param) {
        $iv6Yc._1(setStickyElement, function(param) {
            return getStickyElement(undefined);
        });
    };
    $g85JO.useEffect(function() {
        $iv6Yc._1(setStickyElement, function(param) {
            return getStickyElement(undefined);
        });
    }, []);
    $78zWm.use({
        attributes: true,
        characterData: false,
        childList: false,
        subtree: false
    }, ref, updateStickyElement);
    return stickyElementRef;
}
function $c4f83c4ab738bfdf$var$useSiteHeaderSize(ref) {
    var el = ref.current;
    var computedStyles = !(el == null) ? $loT9g.some(window.getComputedStyle(el)) : undefined;
    var isSticky = computedStyles !== undefined ? $loT9g.valFromOption(computedStyles).position === "sticky" : false;
    var cssTop = computedStyles !== undefined ? $cHs0A.fromString($loT9g.valFromOption(computedStyles).top) : undefined;
    var cssTransformTop = computedStyles !== undefined ? $2whNH.flatMap($7GW0c.StyleDeclaration.fromCssStyleDeclatation($loT9g.valFromOption(computedStyles)).transform, function(transform) {
        return $2whNH.map(transform.matrix, function(param) {
            return param[5];
        });
    }) : undefined;
    var size = $cTjaa.useResizeObserver(undefined, ref);
    var match = $ePG8R.use(30, true, function(param) {
        return Date.now();
    });
    var setTimestamp = match[1];
    var timeoutId = $g85JO.useRef(undefined);
    var height = $2whNH.map(size, function(size) {
        return size.height;
    });
    var top = $2whNH.map(size, function(size) {
        return size.top;
    });
    var scrollTop = window.scrollY;
    var totalCssTop = cssTop !== undefined ? cssTransformTop !== undefined ? cssTop + cssTransformTop | 0 : cssTop : cssTransformTop !== undefined ? cssTransformTop : undefined;
    var isStuck = isSticky && scrollTop > $2whNH.mapWithDefault(top, 0.0, function(prim) {
        return prim;
    });
    var top$1 = isSticky && totalCssTop !== undefined ? totalCssTop + (isStuck ? 0 : $2whNH.getWithDefault(top, 0)) | 0 : top;
    var initialTop = $g85JO.useRef(top$1);
    $g85JO.useEffect(function() {
        var match = initialTop.current;
        if (match !== undefined) ;
        else initialTop.current = top$1;
    }, [
        top$1
    ]);
    var top$2 = $2whNH.flatMap(top$1, function(top) {
        return $2whNH.map(initialTop.current, function(initialTop) {
            return Math.min(top, initialTop);
        });
    });
    var $$clearTimeout$1 = function $$clearTimeout$1(param) {
        $2whNH.forEach(timeoutId.current, function(timeoutId) {
            clearTimeout(timeoutId);
        });
    };
    var forceThrottledRerender = function forceThrottledRerender(param) {
        var el = ref.current;
        if (el == null) return;
        $$clearTimeout$1(undefined);
        var computedStyles = $7GW0c.StyleDeclaration.fromCssStyleDeclatation(window.getComputedStyle(el));
        var transitionDuration = computedStyles.transitionDuration;
        var transitionDelay = computedStyles.transitionDelay;
        var timeoutDelay = (transitionDuration + transitionDelay + 0.1) * 1000 | 0;
        timeoutId.current = $loT9g.some(setTimeout(function(param) {
            $iv6Yc._1(setTimestamp, function(param) {
                return Date.now();
            });
        }, timeoutDelay));
    };
    $78zWm.use({
        attributes: true,
        characterData: false,
        childList: false,
        subtree: false
    }, ref, forceThrottledRerender);
    $iJp5F.use(ref, undefined, undefined, [
        0.0,
        0.1,
        0.2,
        0.3,
        0.4,
        0.5,
        0.6,
        0.7,
        0.8,
        0.9,
        1.0
    ], undefined, 0, undefined, undefined);
    $hBcYV.useRouter(undefined);
    $lx43R.useWindow(true, undefined, undefined, undefined, undefined);
    return [
        height,
        top$2
    ];
}
function $c4f83c4ab738bfdf$var$StickyHeaderOffsetProvider$Selector(Props) {
    var selector = Props.selector;
    var callback = Props.callback;
    var originalRef = $hv3Nv.use(undefined, selector);
    var stickyRef = $c4f83c4ab738bfdf$var$useStickySiteHeader(originalRef);
    var getRef = function getRef(param) {
        var match = stickyRef.current;
        var match$1 = originalRef.current;
        if (match == null) {
            if (match$1 == null) return null;
            else return match$1;
        } else return match;
    };
    var ref = $g85JO.useRef(getRef(undefined));
    $g85JO.useEffect(function() {
        ref.current = getRef(undefined);
    });
    var addUpOptions = function addUpOptions(a, b) {
        return $i7mYY.reduce($i7mYY.map([
            a,
            b
        ], function(v) {
            return $2whNH.getWithDefault(v, -1);
        }), 0, function(acc, next) {
            return acc + next | 0;
        });
    };
    var match = $c4f83c4ab738bfdf$var$useSiteHeaderSize(ref);
    var top = match[1];
    var height = match[0];
    var value = addUpOptions(height, top);
    var overrideRef = $g85JO.useMemo(function() {
        var el = originalRef.current;
        if (!(el == null) && value === 0) return {
            current: el
        };
        else return {
            current: null
        };
    }, [
        value
    ]);
    var match$1 = $c4f83c4ab738bfdf$var$useSiteHeaderSize(overrideRef);
    var value$1 = addUpOptions(match$1[0], match$1[1]);
    var overrideValue = value$1 <= 0 ? undefined : value$1;
    var value$2 = $2whNH.getWithDefault(overrideValue, value);
    $g85JO.useEffect(function() {
        $iv6Yc._2(callback, selector, {
            value: value$2,
            containerTop: 0,
            containerSize: undefined,
            containerRef: $c4f83c4ab738bfdf$var$empty_containerRef,
            isEffective: $2whNH.isSome($loT9g.nullable_to_opt(stickyRef.current)),
            forceEffectiveness: false
        });
        return function(param) {
            $iv6Yc._2(callback, selector, $c4f83c4ab738bfdf$export$6e22c362a0406a2c);
        };
    }, [
        height,
        top,
        value$2
    ]);
    return null;
}
$c4f83c4ab738bfdf$var$StickyHeaderOffsetProvider$Selector.displayName = "StickyHeaderOffsetProvider.Selector";
var $c4f83c4ab738bfdf$export$d15f4cd5286f9b1e = {
    useStickySiteHeader: $c4f83c4ab738bfdf$var$useStickySiteHeader,
    useSiteHeaderSize: $c4f83c4ab738bfdf$var$useSiteHeaderSize,
    make: $c4f83c4ab738bfdf$var$StickyHeaderOffsetProvider$Selector
};
function $c4f83c4ab738bfdf$var$StickyHeaderOffsetProvider(Props) {
    var attributes = Props.attributes;
    var forceEffectivenessOpt = Props.forceEffectiveness;
    var className = Props.className;
    var children = Props.children;
    var forceEffectiveness = forceEffectivenessOpt !== undefined ? forceEffectivenessOpt : false;
    var containerRef = $g85JO.useRef(null);
    var initialContainerTop = $g85JO.useRef(undefined);
    var containerSize = $cTjaa.useResizeObserver(undefined, containerRef);
    var containerTop = $2whNH.map(containerSize, function(size) {
        return size.top;
    });
    $g85JO.useEffect(function() {
        var match = initialContainerTop.current;
        if (match !== undefined || containerTop === undefined) ;
        else initialContainerTop.current = containerTop;
    }, [
        containerTop
    ]);
    var match = $g85JO.useState(function() {
        return {};
    });
    var setDict = match[1];
    var dict = match[0];
    var match$1 = $8E2YL.use(undefined).config;
    var selector = $2whNH.orElse($2whNH.flatMap(attributes, function(attr) {
        return attr.siteHeaderTarget;
    }), $avqDR.getSiteHeaderCSSSelector(match$1.settings, match$1.transitiveAccount));
    var selectors = $2whNH.mapWithDefault(selector, [], function(__x) {
        return __x.split(",");
    }).map(function(prim) {
        return prim.trim();
    });
    var callback = $g85JO.useCallback(function(selector) {
        return function(value) {
            var previousValue = $d3YYW.get(dict, selector);
            return $iv6Yc._1(setDict, function(dict) {
                return $d3YYW.fromArray($d3YYW.entries(dict).filter(function(param) {
                    return param[0] !== selector;
                }).concat(value !== undefined ? [
                    [
                        selector,
                        value
                    ]
                ] : previousValue !== undefined ? [
                    [
                        selector,
                        previousValue
                    ]
                ] : []));
            });
        };
    }, [
        dict,
        setDict
    ]);
    var selectorElements = selectors.map(function(selector, i) {
        return /*#__PURE__*/ $g85JO.createElement($c4f83c4ab738bfdf$var$StickyHeaderOffsetProvider$Selector, {
            selector: selector,
            callback: callback,
            key: "" + selector + "-" + String(i) + ""
        });
    });
    var ctxValue = $g85JO.useMemo(function() {
        return {
            value: 0,
            containerTop: $2whNH.getWithDefault(containerTop, 0),
            containerSize: containerSize,
            containerRef: containerRef,
            isEffective: false,
            forceEffectiveness: false
        };
    }, [
        containerTop,
        containerSize
    ]);
    var ctxValue$1 = $g85JO.useMemo(function() {
        return $2whNH.mapWithDefault($i7mYY.get($58Tj9.stableSortBy($d3YYW.values(dict), function(a, b) {
            if (b.value > a.value) return 1;
            else return -1;
        }), 0), ctxValue, function(t) {
            return {
                value: Math.max(t.value, 0),
                containerTop: ctxValue.containerTop,
                containerSize: ctxValue.containerSize,
                containerRef: ctxValue.containerRef,
                isEffective: t.isEffective,
                forceEffectiveness: forceEffectiveness
            };
        });
    }, [
        dict,
        containerTop,
        containerSize
    ]);
    var tmp = {
        ref: $5bEXW.Ref.domRef(containerRef)
    };
    if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
    var children$1 = /*#__PURE__*/ $g85JO.createElement("div", tmp, children, selectorElements);
    return /*#__PURE__*/ $g85JO.createElement($c4f83c4ab738bfdf$export$ca328f169d304df4, {
        value: ctxValue$1,
        children: children$1
    });
}
$c4f83c4ab738bfdf$var$StickyHeaderOffsetProvider.displayName = "StickyHeaderOffsetProvider";
function $c4f83c4ab738bfdf$export$1f96ae73734a86cc(param) {
    return $g85JO.useContext($c4f83c4ab738bfdf$export$a078c61943f9dbbe);
}
function $c4f83c4ab738bfdf$export$1ed10c548f3d9369(param) {
    var match = $9pMGg.use(undefined);
    var ctx = $g85JO.useContext($c4f83c4ab738bfdf$export$a078c61943f9dbbe);
    var nextValue = match.embedType === /* Inline */ 1 ? ctx.containerTop - ctx.value | 0 : 0;
    var result = $g85JO.useRef(nextValue);
    $g85JO.useEffect(function() {
        result.current = nextValue > result.current && nextValue > 0 ? nextValue : result.current;
    }, [
        nextValue
    ]);
    return result.current;
}
function $c4f83c4ab738bfdf$export$e13c6a3d46905eb0(param) {
    var ctx = $g85JO.useContext($c4f83c4ab738bfdf$export$a078c61943f9dbbe);
    if (ctx.isEffective || ctx.forceEffectiveness) return ctx.value - 1 | 0;
    else return 0;
}
function $c4f83c4ab738bfdf$export$85a6055c7d8da58f(param) {
    var match = $8E2YL.use(undefined);
    var match$1 = $g85JO.useContext($c4f83c4ab738bfdf$export$a078c61943f9dbbe);
    if (match.config.settings.siteHeaderRespect || match$1.forceEffectiveness) return match$1.value - 1 | 0;
    else return 0;
}
function $c4f83c4ab738bfdf$export$fccf794fa3536868(param) {
    return $g85JO.useContext($c4f83c4ab738bfdf$export$a078c61943f9dbbe).value;
}
function $c4f83c4ab738bfdf$export$196a7e160e85974(param) {
    var match = $aSJcu.use(undefined);
    var stickyHeaderOffset = $c4f83c4ab738bfdf$export$85a6055c7d8da58f(undefined);
    return match.windowSize.height - stickyHeaderOffset | 0;
}
var $c4f83c4ab738bfdf$export$dd44f18ab656f3bb = $c4f83c4ab738bfdf$var$StickyHeaderOffsetProvider;
 /* empty Not a pure module */ 
});
parcelRegister("avqDR", function(module, exports) {

$parcel$export(module.exports, "getSiteHeaderCSSSelector", function () { return $7a61772cd46b481f$export$35b277e5d428e1cd; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $2whNH = parcelRequire("2whNH");
function $7a61772cd46b481f$var$fromString(panelSize) {
    switch(panelSize){
        case "large":
            return /* Large */ 0;
        case "medium":
            return /* Medium */ 1;
        case "small":
            return /* Small */ 2;
        default:
            return /* Large */ 0;
    }
}
function $7a61772cd46b481f$var$toString(panelSize) {
    if (panelSize === 0) return "large";
    switch(panelSize){
        case /* Medium */ 1:
            return "medium";
        case /* Small */ 2:
            return "small";
        case /* FullWidth */ 3:
            return "large";
    }
}
var $7a61772cd46b481f$export$69e2902d2a3921ff = {
    fromString: $7a61772cd46b481f$var$fromString,
    toString: $7a61772cd46b481f$var$toString
};
function $7a61772cd46b481f$var$fromString$1(panelPosition) {
    if (panelPosition === "left") return /* Left */ 0;
    else return /* Right */ 1;
}
var $7a61772cd46b481f$export$a048ae1f0ae09c2c = {
    fromString: $7a61772cd46b481f$var$fromString$1
};
function $7a61772cd46b481f$export$35b277e5d428e1cd(settings, account) {
    return $2whNH.orElse(settings.siteHeaderCSSSelector, $2whNH.flatMap(account, function(account) {
        return account.siteHeaderCSSSelector;
    }));
}
 /* No side effect */ 
});

parcelRegister("lx43R", function(module, exports) {

$parcel$export(module.exports, "Jammer", function () { return $facfd485086f448e$export$9b6002db3d45a06b; });
$parcel$export(module.exports, "useScrollable", function () { return $facfd485086f448e$export$79e8db7c10e50c32; });
$parcel$export(module.exports, "useWindow", function () { return $facfd485086f448e$export$24b8fbafc4b6a151; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ePG8R = parcelRequire("ePG8R");

var $7GW0c = parcelRequire("7GW0c");

var $2XXXw = parcelRequire("2XXXw");

var $3s6k1 = parcelRequire("3s6k1");
function $facfd485086f448e$export$f84e8e69fd4488a5(direction) {
    if (direction) return "Down";
    else return "Up";
}
var $facfd485086f448e$var$jammed = {
    contents: false
};
function $facfd485086f448e$var$jam(param) {
    $facfd485086f448e$var$jammed.contents = true;
}
function $facfd485086f448e$var$unjam(param) {
    $facfd485086f448e$var$jammed.contents = false;
}
function $facfd485086f448e$var$isJammed(param) {
    return $facfd485086f448e$var$jammed.contents;
}
var $facfd485086f448e$export$9b6002db3d45a06b = {
    jammed: $facfd485086f448e$var$jammed,
    jam: $facfd485086f448e$var$jam,
    unjam: $facfd485086f448e$var$unjam,
    isJammed: $facfd485086f448e$var$isJammed
};
function $facfd485086f448e$export$79e8db7c10e50c32(enabledOpt, element, initialDirectionOpt, thresholdOpt, param) {
    var enabled = enabledOpt !== undefined ? enabledOpt : true;
    var initialDirection = initialDirectionOpt !== undefined ? initialDirectionOpt : /* Up */ 0;
    var threshold = thresholdOpt !== undefined ? thresholdOpt : 5;
    var match = $ePG8R.use(undefined, undefined, function(param) {
        return initialDirection;
    });
    var setScrollDirection = match[1];
    var lastScrollPosition = $g85JO.useRef(0);
    var lastScrollDirection = $g85JO.useRef(/* Up */ 0);
    var onScroll = function onScroll(e) {
        if (!(enabled && !$2XXXw.isBlockingOnScrollEvent(undefined) && !$facfd485086f448e$var$jammed.contents)) return;
        var target = e.target;
        var scrollTop = target.scrollTop | 0;
        var nextDirection = scrollTop !== 0 ? (scrollTop - threshold | 0) > lastScrollPosition.current ? /* Down */ 1 : (scrollTop + threshold | 0) < lastScrollPosition.current ? /* Up */ 0 : lastScrollDirection.current : /* Up */ 0;
        $iv6Yc._1(setScrollDirection, function(param) {
            return nextDirection;
        });
        lastScrollPosition.current = scrollTop;
        lastScrollDirection.current = nextDirection;
    };
    var addListener = function addListener(element) {
        element.addEventListener("scroll", onScroll, {
            capture: false,
            passive: true,
            once: false
        });
    };
    var removeListener = function removeListener(element) {
        element.removeEventListener("scroll", onScroll, {
            capture: false,
            passive: true
        });
    };
    $g85JO.useEffect(function() {
        if (element === undefined) return;
        if (!enabled) return;
        var element$1 = $loT9g.valFromOption(element);
        removeListener(element$1);
        addListener(element$1);
        return function(param) {
            removeListener(element$1);
        };
    }, [
        element
    ]);
    return [
        match[0],
        setScrollDirection
    ];
}
function $facfd485086f448e$export$24b8fbafc4b6a151(enabledOpt, onScroll, initialDirectionOpt, thresholdOpt, param) {
    var enabled = enabledOpt !== undefined ? enabledOpt : true;
    var initialDirection = initialDirectionOpt !== undefined ? initialDirectionOpt : /* Up */ 0;
    var threshold = thresholdOpt !== undefined ? thresholdOpt : 5;
    var match = $ePG8R.use(undefined, undefined, function(param) {
        return initialDirection;
    });
    var setScrollDirection = match[1];
    var lastScrollPosition = $g85JO.useRef(0);
    var lastScrollDirection = $g85JO.useRef(/* Up */ 0);
    var onScroll$1 = function onScroll$1(e) {
        if (!(!$3s6k1.isBlockingOnScrollEvent(undefined) && !$facfd485086f448e$var$jammed.contents)) return;
        var scrollTop = $iv6Yc._1($7GW0c.$$Window.scrollY, undefined) | 0;
        var nextDirection = scrollTop !== 0 ? (scrollTop - threshold | 0) > lastScrollPosition.current ? /* Down */ 1 : (scrollTop + threshold | 0) < lastScrollPosition.current ? /* Up */ 0 : lastScrollDirection.current : /* Up */ 0;
        $iv6Yc._1(setScrollDirection, function(param) {
            return nextDirection;
        });
        lastScrollPosition.current = scrollTop;
        lastScrollDirection.current = nextDirection;
        $2whNH.forEach(onScroll, function(cb) {
            $iv6Yc._2(cb, nextDirection, scrollTop);
        });
    };
    $g85JO.useEffect(function() {
        if (enabled) window.addEventListener("scroll", onScroll$1, {
            capture: false,
            passive: true,
            once: false
        });
        return function(param) {
            window.removeEventListener("scroll", onScroll$1, {
                capture: false,
                passive: true
            });
        };
    }, [
        enabled
    ]);
    return [
        match[0],
        setScrollDirection
    ];
}
 /* react Not a pure module */ 
});
parcelRegister("3s6k1", function(module, exports) {

$parcel$export(module.exports, "isBlockingOnScrollEvent", function () { return $2838e4065aa467f6$export$51e57029e6716073; });
$parcel$export(module.exports, "useGlobalScrollRestoration", function () { return $2838e4065aa467f6$export$6f91e7af12d0519b; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $dLC6y = parcelRequire("dLC6y");

var $kQvlq = parcelRequire("kQvlq");

var $kJhYp = parcelRequire("kJhYp");

var $7GW0c = parcelRequire("7GW0c");

var $gO2mJ = parcelRequire("gO2mJ");

var $efwy1 = parcelRequire("efwy1");

var $25dxq = parcelRequire("25dxq");

var $2XXXw = parcelRequire("2XXXw");

var $hv3Nv = parcelRequire("hv3Nv");
$gO2mJ.setScrollRestoration("manual");
var $2838e4065aa467f6$var$blockingOnScrollEvent = {
    contents: false
};
function $2838e4065aa467f6$export$aded8d3ce7fe43e1(bool) {
    $2838e4065aa467f6$var$blockingOnScrollEvent.contents = bool;
}
function $2838e4065aa467f6$export$51e57029e6716073(param) {
    return $2838e4065aa467f6$var$blockingOnScrollEvent.contents;
}
function $2838e4065aa467f6$export$85c5d4ae50531531(fn) {
    var match = $kQvlq.useSafeTimeout(undefined, undefined);
    var $$clearTimeout = match.clearTimeout;
    var $$setTimeout = match.setTimeout;
    var lastScrollHeightRef = $g85JO.useRef(0);
    var ref = $hv3Nv.use(undefined, "body");
    var loop = function loop1(param) {
        $$setTimeout(function(param) {
            var el = ref.current;
            if (!(el == null) && el.scrollHeight !== lastScrollHeightRef.current) {
                $iv6Yc._1(fn, undefined);
                lastScrollHeightRef.current = el.scrollHeight;
            }
            $iv6Yc._1($$clearTimeout, undefined);
            loop(undefined);
        }, 100);
    };
    $g85JO.useEffect(function() {
        loop(undefined);
    }, []);
}
function $2838e4065aa467f6$export$3d0b964c6901b06d(param) {
    var id = "smartnav-overflow-anchor-style";
    $g85JO.useEffect(function() {
        var style = document.getElementById(id);
        if (style == null) {
            var arg = document.createTextNode("body { overflow-anchor: none; }");
            var arg$1 = $dLC6y.tap($dLC6y.tap(document.createElement("style"), function(__x) {
                __x.setAttribute("id", id);
            }), function(param) {
                param.appendChild(arg);
            });
            $2whNH.forEach($7GW0c.$$Document.body(document), function(param) {
                param.appendChild(arg$1);
            });
        }
        return function(param) {
            var style = document.getElementById(id);
            if (!(style == null)) {
                style.remove();
                return;
            }
        };
    }, []);
}
function $2838e4065aa467f6$export$6f91e7af12d0519b(idOpt, offset, embedHeight, param) {
    var id = idOpt !== undefined ? idOpt : "global";
    $2838e4065aa467f6$export$3d0b964c6901b06d(undefined);
    var match = $efwy1.use(undefined);
    var namespace = match.namespace;
    var timeout1 = $kQvlq.useSafeTimeout(undefined, undefined);
    var timeout2 = $kQvlq.useSafeTimeout(undefined, undefined);
    var isOverlay = function isOverlay(param) {
        if ($2whNH.isSome($kJhYp.getStatesByNamespace(namespace).current.quickView.mediaId)) return true;
        else return $2whNH.mapWithDefault($kJhYp.getStatesByNamespace(namespace).current.quickNav, false, function(loc) {
            return $2whNH.isSome(loc.productId);
        });
    };
    var offsetRef = $g85JO.useRef(0);
    var previousScroll = $g85JO.useRef(0);
    var updatePreviousScroll = function updatePreviousScroll(scrollY) {
        var willUpdate = !isOverlay(undefined) && !$2838e4065aa467f6$export$51e57029e6716073(undefined);
        previousScroll.current = willUpdate ? scrollY : previousScroll.current;
    };
    var getCurrentKey = function getCurrentKey(param) {
        return $kJhYp.toQueryString(undefined, $kJhYp.sanitizeLocation($kJhYp.getStatesByNamespace(namespace).current));
    };
    var getSavedScrollY = function getSavedScrollY(localStorageOpt, offset) {
        var localStorage = localStorageOpt !== undefined ? localStorageOpt : false;
        var match = $2XXXw.getScroll(namespace, localStorage, id);
        var match$1 = !isOverlay(undefined);
        if (typeof match !== "number" && match.TAG === /* Pixels */ 0) {
            if (match$1 && previousScroll.current >= offset) return Math.max(match._0, offset);
            else return;
        }
        if (match$1 && previousScroll.current >= offset) return $2XXXw.getClosestBreakingPoint(previousScroll.current, offset);
    };
    var scrollTo = function scrollTo(y) {
        window.scrollTo(0.0, y);
    };
    var applyScroll = function applyScroll(param) {
        var savedScrollY = getSavedScrollY(undefined, offsetRef.current);
        var currentScrollY = $dLC6y.tap($iv6Yc._1($7GW0c.$$Window.scrollY, undefined) | 0, updatePreviousScroll);
        if (savedScrollY !== undefined && savedScrollY !== currentScrollY) return scrollTo(savedScrollY);
    };
    var lastKey = $g85JO.useRef(getCurrentKey(undefined));
    $2838e4065aa467f6$export$85c5d4ae50531531(function(param) {
        if ($2838e4065aa467f6$export$51e57029e6716073(undefined)) return applyScroll(undefined);
    });
    var applyOnLocationChange = function applyOnLocationChange(offset) {
        offsetRef.current = offset;
        var apply = function apply(param) {
            var currentKey = getCurrentKey(undefined);
            var savedScrollY = getSavedScrollY(undefined, offset);
            if (savedScrollY !== undefined && lastKey.current !== currentKey) {
                $2838e4065aa467f6$export$aded8d3ce7fe43e1(true);
                scrollTo(savedScrollY);
                timeout1.setTimeout(function(param) {
                    applyScroll(undefined);
                    timeout2.setTimeout(function(param) {
                        $2838e4065aa467f6$export$aded8d3ce7fe43e1(false);
                    }, 100);
                }, 0);
            }
            lastKey.current = currentKey;
        };
        var removePreviousCallback = function removePreviousCallback(param) {
            $kJhYp.setLocalCallbacksByNamespace(namespace, $i7mYY.keep($kJhYp.getStatesByNamespace(namespace).localCallbacks, function(fn) {
                return fn !== apply;
            }));
        };
        var addCallback = function addCallback(param) {
            $kJhYp.setLocalCallbacksByNamespace(namespace, $i7mYY.concat($kJhYp.getStatesByNamespace(namespace).localCallbacks, [
                apply
            ]));
        };
        removePreviousCallback(undefined);
        addCallback(undefined);
        return function(param) {
            removePreviousCallback(undefined);
        };
    };
    var saveOnScroll = function saveOnScroll(offset) {
        var save = function save(param) {
            var currentScroll = $dLC6y.tap($iv6Yc._1($7GW0c.$$Window.scrollY, undefined) | 0, updatePreviousScroll);
            if ($2838e4065aa467f6$export$51e57029e6716073(undefined)) return $2XXXw.ScrollRestorationLocalStorage.set(id, {
                TAG: /* Pixels */ 0,
                _0: offset
            });
            else return $2XXXw.setCurrentScroll(namespace, id, {
                TAG: /* Pixels */ 0,
                _0: currentScroll
            });
        };
        var removePreviousListener = function removePreviousListener(param) {
            window.removeEventListener("scroll", save, {
                capture: false,
                passive: true
            });
        };
        var addListener = function addListener(param) {
            window.addEventListener("scroll", save, {
                capture: false,
                passive: true,
                once: false
            });
        };
        removePreviousListener(undefined);
        addListener(undefined);
        return removePreviousListener;
    };
    var cachedCleanupFns = $g85JO.useRef({});
    var runSparingly = function runSparingly(fn) {
        var fnName = fn.name;
        var isInitialized = function isInitialized(param) {
            return $2whNH.isSome($d3YYW.get(cachedCleanupFns.current, fnName));
        };
        var initialize = function initialize(cleanupFn) {
            cachedCleanupFns.current = $d3YYW.fromArray($i7mYY.concat($d3YYW.entries(cachedCleanupFns.current), [
                [
                    fnName,
                    cleanupFn
                ]
            ]));
        };
        if (offset !== undefined && !isInitialized(undefined)) initialize($iv6Yc._1(fn, offset));
    };
    var cleanUp = function cleanUp(param) {
        $i7mYY.forEach($i7mYY.keepMap($d3YYW.values(cachedCleanupFns.current), function(v) {
            return v;
        }), function(cleanUp) {
            $iv6Yc._1(cleanUp, undefined);
        });
    };
    $g85JO.useEffect(function() {
        return runSparingly(saveOnScroll);
    }, [
        offset
    ]);
    $g85JO.useEffect(function() {
        return runSparingly(applyOnLocationChange);
    }, [
        offset
    ]);
    $g85JO.useEffect(function() {
        return cleanUp;
    }, []);
    $25dxq.useBrowserNavigation(function(navigationType) {
        var offset$1 = $2whNH.getWithDefault(offset, 0);
        var embedHeight$1 = $2whNH.getWithDefault(embedHeight, 0);
        var totalEmbedHeight = offset$1 + embedHeight$1 | 0;
        var px = $2XXXw.getScroll(namespace, true, id);
        var pxToScroll;
        pxToScroll = typeof px === "number" || px.TAG !== /* Pixels */ 0 ? undefined : px._0;
        if (navigationType !== 1) return $2XXXw.ScrollRestorationLocalStorage.$$delete(id);
        else if (pxToScroll !== undefined && pxToScroll > ($iv6Yc._1($7GW0c.$$Window.scrollY, undefined) | 0) && pxToScroll < totalEmbedHeight) return scrollTo(pxToScroll);
        else return;
    }, [
        offset,
        embedHeight
    ]);
}
 /*  Not a pure module */ 
});



})();
//# sourceMappingURL=Entrypoint.bs.a1c8a14a.js.map
